<template>
    <modal
        name="asiento-ocupado"
        transition="pop-out"
        :width="800"
        height="auto"
        scrollable
        id="asiento-ocupado"
        :adaptive="true"
    >
        <div class="card m-0">
            <div class="card-header">
                <div class="row">
                    <div class="col-10">
                        <h2 class="text-dark">{{ $t('partido.asiento_ocupado_title') }}</h2>
                    </div>
                    <div class="col-2">
                        <button type="button" class="close" @click.prevent="close()">
                            <span aria-hidden="true">×</span>
                        </button>
                    </div>
                </div>
            </div>
            <div class="card-body">
                <p style="font-size: 20px;">{{ $t('partido.asiento_ocupado_content') }}</p>
            </div>
            <div class="card-footer text-right">
                <slot name="footer">
                    <Button type="button" name="button" @click.prevent="close()">{{$t('partido.continuar')}}</Button>
                </slot>
            </div>
        </div>
    </modal>
</template>

<script>

    export default {
        methods: {
            close() {
                this.$emit('close');
            }
        },
    }

</script>